require("./bootstrap");

import axios from "axios";
import urlManager from "./urlManager";
import __poppyHandler from "./poppyHandler";
import __errorHandler from "./errorHandler";
import __popperHandler from "./popperHandler";
import __successHandler from "./successHandler";
require("./dropdown");
require("./actions");
require("./table");
require("./datetimepicker");
require("./fileupload");
require("./accordion");
require("./formmedia");
require("./inputhelpers");
require("./filterhelper");
require("./searchlisting");
require("./sortingorder");
require("./tooltips");
require("./formbuilder");

require('./tinymce');

require("./graphs");

require('./payment');
require('./application_status');
require('./accomm_table');
require('./editor');

require('./default_question_handler');

require('./camp_educator');


function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  window.__copyLink = function(event) {

    let target = event.target || event.srcElement;

    if (target) {
      let parent = target.closest('span');
      if (parent) {
        let copy_element = parent.querySelector('.copy-link');
        if (copy_element) {
          let text_to_copy = copy_element.getAttribute('data-link').trim();
          if (text_to_copy) {
            copyTextToClipboard(text_to_copy);
          }
        }
      }
    }

    return false;
  }

  window.__copyInput = function(elm) {
    let copyText = document.getElementById(elm.getAttribute('data-copy-id'));
  
    copyText.select(); 
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
  
    navigator.clipboard.writeText(copyText.value);

    return false;
  }
